import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import HostedPBX from '../components/HostedPBX'
import Table from '../components/Table'

export default class PBXHome extends Component {
    render() {

        const yes = <i className="fas fa-check"></i>;
        const no = "";//<i className="fas fa-times"></i>;
        const pbxFeatures = (
            <Table items={[
                ["PBX Features", "1-4 Users", "5 and Up", "Dedicated"],
                ["Call Transfer/Forwarding", yes, yes, yes],
                ["Voicemail/Voicemail to Email", yes, yes, yes],
                ["Follow Me", yes, yes, yes],
                ["Auto-Attendant/IVR", yes, yes, yes],
                ["Do Not Disturb", yes, yes, yes],
                ["Ext. to Ext. calling", yes, yes, yes],
                ["Music On Hold", yes, yes, yes],
                ["Office Hours", yes, yes, yes],
                ["Remote Users", yes, yes, yes],
                ["Multiple Offices", yes, yes, yes],
                ["Call Parking", no, yes, yes],
                ["Call Queue", no, yes, yes],
                ["Ring Groups", no, yes, yes],
                ["Call Reporting", no, yes, yes],
                ["Caller ID", no, yes, yes],
                ["Phone Directory", no, yes, yes],
                ["Conference Rooms", no, yes, yes],
                ["call Recordings", no, "$20/month", "$20/month"],
                ["and much more…", no, yes, yes],
            ]} />
        );

        return (
            <div style={styles.container}>
                <div className="title" style={styles.title}>Hosted PBX</div>
                <HostedPBX />
                <div style={styles.fixedBottomRightHolder}>
                    <div style={styles.btnsHolder} className="btns-holder">
                        <Link to="/shop/hosted-pbx">
                            <div className="btn">
                                Continue In Shop
                            </div>
                        </Link>
                    </div>
                </div>
                {pbxFeatures}
            </div>
        )
    }
}

const styles = {
    container: {
        margin: "5vh 5vw 10vh",
    },
    title: {
        textAlign: "center",
        color: "#ed9898",
        marginBottom: "2.5vh",
        fontSize: "2rem",
    },
    fixedBottomRightHolder: {
        position: "fixed",
        right: "0",
        bottom: "0",
    },
    btnsHolder: {
        margin: ".75rem 1rem",
    }

}